// Vuex transaction module mutations
import { FILL_HEADERS, FILL_QUEUE, FILL_STATUS_AND_TYPE_DICTIONARY, REMOVE_FROM_QUEUE, FILL_HISTORY, FILL_TEMPLATES, FILL_INCOMING } from './mutations-types';

export default {
  [FILL_HEADERS](state, payload) {
    const _state = state;
    _state.headers = payload;
  },
  [FILL_TEMPLATES](state, payload) {
    const _state = state;
    _state.templates = payload;
  },
  [FILL_QUEUE](state, payload) {
    const _state = state;
    _state.queue = payload;
  },
  [FILL_HISTORY](state, payload) {
    const _state = state;
    _state.history = payload;
  },
  [FILL_INCOMING](state, payload) {
    const _state = state;
    _state.incoming = payload;
  },
  [FILL_STATUS_AND_TYPE_DICTIONARY](state, payload) {
    const _state = state;
    _state.dictionary = {
      status: payload.status,
      type: payload.type,
    };
  },
  [REMOVE_FROM_QUEUE](state, payload) {
    const _state = state;
    _state.queue.records = _state.queue.records.filter(item => item.id !== payload.id);
    _state.queue.total -= 1;
  }
};
